module.exports = __webpack_public_path__ + "media/dashboard/assets/images/customer-support-5e7a5a8d9aa6a8ecd2fd9e284efc2e87.png";